//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { ConvertHelper } from './convert-helper';
import { DataProvider } from '../helpers/data-provider'
import { LocalizationHelper } from '../helpers/localization-helper'
import { TypeHelper } from '../helpers/type-helper'
import { ToastHelper } from './toast-helper';

import { Enums } from '../models/common/enums'
import { OpDevice } from '../models/core/op-device'
import { OpActionResult } from '../models/custom/op-action-result'

import { ActionStatusOptions } from '../modules/common/action-status/action-status.controller'


export class ActionHelper {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.Helpers.ActionHelper] - %s' }

    // Consts End


    // Methods

    /**
     * Sends configuration to the given devices and returns an ActionStatusOptions object.
     */
    public static sendDeviceConfiguration(dataProvider: DataProvider, devices: OpDevice[]): JQueryPromise<ActionStatusOptions>

    /**
     * @deprecated Pass only devices into this method.
     * 
     * TODO Usunąć po przerobieniu starych modułów
     */
    public static sendDeviceConfiguration(dataProvider: DataProvider, deviceIds: number[], deviceNames: string[]): JQueryPromise<ActionStatusOptions>
    public static sendDeviceConfiguration(dataProvider: DataProvider, deviceIdsOrDevice: number[] | OpDevice[], deviceNames?: string[]): JQueryPromise<ActionStatusOptions> {
        const deferred: JQueryDeferred<ActionStatusOptions> = $.Deferred<ActionStatusOptions>()
        let deviceIds: number[] = null

        if (dataProvider != null && deviceIdsOrDevice != null && deviceIdsOrDevice.length > 0) {
            if (TypeHelper.isNumber(deviceIdsOrDevice[0])) {
                deviceIds = deviceIdsOrDevice as number[]
            }
            else {
                const devices: OpDevice[] = deviceIdsOrDevice as OpDevice[]

                deviceIds = []
                deviceNames = []

                devices.forEach((device: OpDevice) => {
                    deviceIds.push(device.serialNbr)
                    deviceNames.push(device.toString())
                })
            }
        }

        if (deviceIds != null && deviceIds.length > 0 && deviceNames != null && deviceNames.length > 0) {
            dataProvider.Device
                .sendDeviceConfiguration(deviceIds)
                .then((response: OpActionResult[]) => {
                    if (response && response.length) {
                        const actionStatusOptions: ActionStatusOptions = {
                            actionResult: response,
                            selectedRowsNames: deviceNames,
                            moduleDataType: Enums.DataType.HELPER_SERIAL_NBR
                        }

                        deferred.resolve(actionStatusOptions)
                    }
                    else {
                        deferred.reject("No response or response empty.")
                    }
                })
                .fail((error: any) => {
                    deferred.reject(error)
                })
        }
        else {
            deferred.reject("Missing or invalid arguments.")
        }

        return deferred
            .fail((error: any) => {
                if (error != null && error.error != null && error.error.msg != null) {
                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                    ToastHelper.showError(errorMsg)
                    console.warn(ActionHelper.LOG_STRING, errorMsg)
                } else {
                    ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendDeviceConfigurationError))
                }

                return $.Deferred<ActionStatusOptions>().reject(error).promise()
            }).promise()
    }

    // Methods End
}